import React from "react";

function RubricItem({ imageUrl, displayName, isActive, onClick }) {
    return (
        <button
            onClick={onClick}
            className={`flex items-center gap-2.5 flex-shrink-0 px-3 py-2 rounded-xl border transition-all cursor-pointer
                ${isActive
                    ? "bg-[#147F26] border-[#147F26] shadow-sm"
                    : "bg-white border-gray-200 hover:border-[#147F26]/40 hover:bg-[#147F26]/5"
                }`}
        >
            <div
                className="w-7 h-7 rounded-full flex-shrink-0 overflow-hidden flex items-center justify-center"
                style={imageUrl && !isActive
                    ? { backgroundImage: `url(${imageUrl})`, backgroundSize: "cover", backgroundPosition: "center" }
                    : { backgroundColor: isActive ? "rgba(255,255,255,0.25)" : "#f3f4f6" }
                }
            >
                {(!imageUrl || isActive) && (
                    <span className={`text-xs font-bold ${isActive ? "text-white" : "text-[#147F26]"}`}>
                        {displayName.charAt(0)}
                    </span>
                )}
            </div>
            <span className={`text-sm font-medium whitespace-nowrap ${isActive ? "text-white" : "text-gray-700"}`}>
                {displayName}
            </span>
        </button>
    );
}

export default RubricItem;
